module.exports = __webpack_public_path__ + "static/media/fresh-factory-img9.d0007217.png";